import { useState } from 'react';
import { FirebaseError } from 'firebase/app';

export function useAuthError() {
  const [authError, setAuthError] = useState<string | null>(null);

  const handleAuthError = (err: unknown) => {
    if (err instanceof FirebaseError) {
      switch (err.code) {
        case 'auth/email-already-in-use':
          setAuthError('This email is already in use');
          break;
        case 'auth/invalid-email':
          setAuthError('Please enter a valid email address');
          break;
        case 'auth/user-not-found':
          setAuthError('No account found with this email');
          break;
        case 'auth/wrong-password':
          setAuthError('Incorrect password');
          break;
        case 'auth/weak-password':
          setAuthError('Password should be at least 6 characters');
          break;
        case 'auth/missing-password':
          setAuthError('Please enter a password');
          break;
        case 'auth/too-many-requests':
          setAuthError('Too many attempts, please try again later');
          break;
        case 'auth/invalid-credential':
          setAuthError('Invalid credentials');
          break;
          case 'auth/admin-restricted-operation':
            setAuthError('Login is not allowed');
            break;
        default:
          setAuthError(err.message.replace('Firebase: ', ''));
      }
    } else if (err instanceof Error) {
      setAuthError(err.message);
    } else {
      setAuthError('An unknown error occurred');
    }
  };

  const clearAuthError = () => setAuthError(null);

  return { authError, handleAuthError, clearAuthError };
}
